// extracted by mini-css-extract-plugin
module.exports = {"box":"ImgPreview-box-1ajuQ","substrate":"ImgPreview-substrate-qQBWT","img":"ImgPreview-img-2-HwH","action":"ImgPreview-action-cEWH8"};